/* tslint:disable */
/* eslint-disable */
/**
 * Farseer API
 * Farseer API
 *
 * The version of the OpenAPI document: 3
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { ColumnMetaFromJSON, ColumnMetaToJSON, HandleMissingTagsFromJSON, HandleMissingTagsToJSON, } from './';
export function ImportJobMetadataFromJSON(json) {
    return ImportJobMetadataFromJSONTyped(json, false);
}
export function ImportJobMetadataFromJSONTyped(json, ignoreDiscriminator) {
    if (json === undefined || json === null) {
        return json;
    }
    return {
        columnMetas: json['columnMetas'].map(ColumnMetaFromJSON),
        dimensionTagIds: json['dimensionTagIds'],
        handleMissingTags: HandleMissingTagsFromJSON(json['handleMissingTags']),
        importZeros: json['importZeros'],
        overwriteCells: json['overwriteCells'],
    };
}
export function ImportJobMetadataToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        columnMetas: value.columnMetas.map(ColumnMetaToJSON),
        dimensionTagIds: value.dimensionTagIds,
        handleMissingTags: HandleMissingTagsToJSON(value.handleMissingTags),
        importZeros: value.importZeros,
        overwriteCells: value.overwriteCells,
    };
}
